import * as React from "react";
const CollabMoneybox = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={45} height={45} {...props}>
    <g transform="translate(12268 10937)">
      <rect
        width={45}
        height={45}
        fill={props.darkMode ? "#fff" : "#383838"}
        rx={22.5}
        transform="translate(-12268 -10937)"
      />
      <path
        fill="#d6b77c"
        d="M-12250-10916.188h-3.375v-3.375h-2.25v3.375h-3.375v2.25h3.375v3.375h2.25v-3.375h3.375Zm11.25 1.125a3.375 3.375 0 1 0-1.024-6.593 5.551 5.551 0 0 1 1.013 3.218 5.66 5.66 0 0 1-1.013 3.218 3.363 3.363 0 0 0 1.024.157Zm-5.625 0a3.375 3.375 0 1 0-3.375-3.375 3.361 3.361 0 0 0 3.375 3.375Zm7.447 2.43a4.162 4.162 0 0 1 1.552 3.2v2.25h3.376v-2.25c0-1.737-2.666-2.806-4.927-3.2Zm-7.447-.18c-2.25 0-6.75 1.125-6.75 3.375v2.25h13.5v-2.25c0-2.25-4.5-3.375-6.75-3.375Z"
        data-name="Icon material-group-add"
      />
    </g>
  </svg>
);
export default CollabMoneybox;
